export default "__VITE_ASSET__CGftmwFD__"